import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import headerai from "../assets/img/ai_studio-19.05.webp"
import headerlab from "../assets/img/lab-19.05.webp"
import hizmetone from "../assets/img/dijital-danismanlik-headernew.webp"
import hizmetseo from "../assets/img/seo-headernew.webp"
import hizmetyapay from "../assets/img/yapay-zeka-headernew.webp"
import hizmetweb from "../assets/img/web-headernew.webp"
import hizmetsocial from "../assets/img/social-media-headernew.webp"
import hizmetdesign from "../assets/img/design-headernew.webp"
import hizmetreklam from "../assets/img/dijital-reklam-headernew.webp"
import hizmeticerik from "../assets/img/icerik-pazarlama-headernew.webp"
import hizmetwp from "../assets/img/wp-marketing-headernew.webp"
import hizmetpro from "../assets/img/produksuyon-headernew.webp"
import answer from "../assets/img/answer-engine-optimization.webp"
import generative from "../assets/img/generative-ai-danismanligi.webp"
import aihizmet from "../assets/img/aiagent.webp"
import ugc from "../assets/img/ugc-agc.webp"
import meetup from "../assets/img/ai-meetup.webp"
import ailab from "../assets/img/flatart-ai-header-menu.webp"
import aiheader from "../assets/img/lab-header-menu-proje.webp"
import livechatai from "../assets/img/livechatai-header.webp"
import popupsmart from "../assets/img/popupsmart-header.webp"
import whatsappapp from "../assets/img/wp-marketing-header-uptade.webp"
import qrcode from "../assets/img/qr-code-dynamic-header.webp"


function openMenu() {
  const menu = document.querySelector('.nav-bar_mobil');

  if (!menu.classList.contains('mobil-active')) {
    menu.classList.add('mobil-active');
    menu.classList.remove('mobil-deactive');
  } else {
    menu.classList.add('mobil-deactive');
    menu.classList.remove('mobil-active');
  }
}


const Header = ({ siteTitle }) => (
  <header>
    <div className="container nav-bar">
      <Link to="/" style={{ height: 25 }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="95.796" height="auto" viewBox="0 0 130.796 35.5" className="logo">
          <g id="Group_4" data-name="Group 4" transform="translate(-703.965 -219.536)">
            <g id="Group_3" data-name="Group 3" transform="translate(703.965 219.536)">
              <path id="Path_47" data-name="Path 47" d="M851.619,237.462v-4.639H846.54v-7.569h-6.934v7.569h-4.2v4.639h4.2v14.893a6.449,6.449,0,0,0,.635,3.077,4.516,4.516,0,0,0,1.734,1.806,7.186,7.186,0,0,0,2.539.854,20.164,20.164,0,0,0,3.052.22q1.026,0,2.1-.049a16.42,16.42,0,0,0,1.953-.2V252.7a9.444,9.444,0,0,1-1.026.146c-.359.033-.732.049-1.123.049a2.348,2.348,0,0,1-2.93-2.93v-12.5Z" transform="translate(-720.823 -223.203)" fill="#030504" />
              <path id="Path_48" data-name="Path 48" d="M734.07,245.766a11.832,11.832,0,0,0-3.565-1.05,28.373,28.373,0,0,0-3.857-.269,21.3,21.3,0,0,0-4.175.415,11.922,11.922,0,0,0-3.736,1.392A8.318,8.318,0,0,0,716,248.842a8.052,8.052,0,0,0-1.221,4.054h6.934a3.921,3.921,0,0,1,1.367-2.93,5.262,5.262,0,0,1,3.223-.88,11.676,11.676,0,0,1,1.733.122,3.861,3.861,0,0,1,1.417.489,2.7,2.7,0,0,1,.977,1.026,3.681,3.681,0,0,1,.366,1.782,1.877,1.877,0,0,1-.635,1.636,4.681,4.681,0,0,1-1.856.855,18.531,18.531,0,0,1-2.686.439q-1.515.147-3.077.391a29.285,29.285,0,0,0-3.1.659,8.768,8.768,0,0,0-2.735,1.245,6.327,6.327,0,0,0-1.953,2.222,7.357,7.357,0,0,0-.757,3.54,7.919,7.919,0,0,0,.659,3.369,6.357,6.357,0,0,0,1.831,2.344,7.711,7.711,0,0,0,2.734,1.367,12.4,12.4,0,0,0,3.37.439,15.672,15.672,0,0,0,4.59-.684,9.025,9.025,0,0,0,3.907-2.393v2.442h6.641V251.626a6.068,6.068,0,0,0-1.026-3.687A7.019,7.019,0,0,0,734.07,245.766ZM720.934,263.2c0-4.574,10.167-5.246,10.167-5.246C731.1,269.254,720.934,267.773,720.934,263.2Z" transform="translate(-642.965 -235.511)" fill="#030504" />
              <path id="Path_49" data-name="Path 49" d="M612.975,245.766a11.833,11.833,0,0,0-3.564-1.05,28.374,28.374,0,0,0-3.857-.269,21.306,21.306,0,0,0-4.176.415,11.924,11.924,0,0,0-3.736,1.392,8.318,8.318,0,0,0-2.734,2.588,8.055,8.055,0,0,0-1.221,4.054h6.934a3.918,3.918,0,0,1,1.367-2.93,5.26,5.26,0,0,1,3.223-.88,11.676,11.676,0,0,1,1.733.122,3.858,3.858,0,0,1,1.416.489,2.7,2.7,0,0,1,.977,1.026,3.677,3.677,0,0,1,.366,1.782,1.876,1.876,0,0,1-.635,1.636,4.682,4.682,0,0,1-1.855.855,18.538,18.538,0,0,1-2.686.439q-1.514.147-3.077.391a29.308,29.308,0,0,0-3.1.659,8.771,8.771,0,0,0-2.735,1.245,6.322,6.322,0,0,0-1.953,2.222,7.353,7.353,0,0,0-.757,3.54,7.913,7.913,0,0,0,.66,3.369A6.349,6.349,0,0,0,595.4,269.2a7.7,7.7,0,0,0,2.734,1.367,12.394,12.394,0,0,0,3.369.439,15.677,15.677,0,0,0,4.59-.684A9.026,9.026,0,0,0,610,267.935v2.442h6.641V251.626a6.07,6.07,0,0,0-1.026-3.687A7.022,7.022,0,0,0,612.975,245.766ZM599.839,263.2c0-4.574,10.167-5.246,10.167-5.246C610.006,269.254,599.839,267.773,599.839,263.2Z" transform="translate(-565.307 -235.511)" fill="#030504" />
              <path id="Path_50" data-name="Path 50" d="M528.563,219.536q-4.249,0-6.348,2.148a7.566,7.566,0,0,0-2.1,5.518v1.953h-4.151v4.639h4.151V254.4h6.934V233.795h4.785v-4.639H527.05v-1.514a3.239,3.239,0,0,1,.611-2.222,2.659,2.659,0,0,1,2.027-.659,21.257,21.257,0,0,1,2.539.146v-5.176q-.879-.048-1.806-.122T528.563,219.536Z" transform="translate(-515.965 -219.536)" fill="#030504" />
              <rect id="Rectangle_2" data-name="Rectangle 2" width="6.934" height="34.865" transform="translate(18.918)" fill="#030504" />
              <path id="Path_51" data-name="Path 51" d="M675.068,225.254h-6.934v7.569h-4.2v4.639h4.2v14.893a6.449,6.449,0,0,0,.635,3.077,4.516,4.516,0,0,0,1.734,1.806,7.187,7.187,0,0,0,2.539.854,20.164,20.164,0,0,0,3.052.22q1.025,0,2.1-.049a16.417,16.417,0,0,0,1.953-.2V252.7a9.443,9.443,0,0,1-1.026.146c-.359.033-.732.049-1.123.049a2.348,2.348,0,0,1-2.93-2.93v-12.5h5.079v-4.639h-5.079Z" transform="translate(-610.858 -223.203)" fill="#030504" />
              <g id="Group_2" data-name="Group 2" transform="translate(97.165 9.661)">
                <path id="Path_52" data-name="Path 52" d="M796.971,247.836a10.985,10.985,0,0,0-3.545,4.234v-5.6h-6.581v25.2h6.581V260.5a14.928,14.928,0,0,1,.48-3.558,8.249,8.249,0,0,1,1.557-3.187,6.679,6.679,0,0,1,2.822-1.995,11.7,11.7,0,0,1,4.233-.682v-4.6A9.3,9.3,0,0,0,796.971,247.836Z" transform="translate(-786.845 -246.468)" fill="#030504" />
                <path id="Path_53" data-name="Path 53" d="M793.645,318.224h.025l-.025-.008Z" transform="translate(-791.206 -292.48)" fill="red" />
              </g>
            </g>
          </g>
        </svg>
      </Link>
      <div className="mobil-icon" onClick={openMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Desktop Menu */}
      <div className="nav-bar_menu">
        <ul>
          <li><Link to="/about/" activeClassName="active-nav">Let's meet</Link></li>
          <li><Link to="/brands/" activeClassName="active-nav">Brands</Link></li>

          {/* Services Dropdown */}
          <li id="dropdown" className="li-header-2025">
            <Link className="header-2025" to="/services/" id="dropdown-Links" activeClassName="active-nav">
              <div className="inner-content">
                Services
                <svg className="svg-2025" xmlns="http://www.w3.org/2000/svg" width="10.822" height="7.797" viewBox="0 0 29.822 18.797">
                  <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                    <path id="Combined-Shape" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111"></path>
                  </g>
                </svg>
              </div>
            </Link>
            <div className="dropdown-menu container uploads testing">
              <div className="col-md-4 header-deskttop">
                <div style={{ fontWeight: 500, fontSize: 18, fontFamily: "itc-avant-garde-gothic-pro" }}>360°</div>
                <div style={{ fontWeight: 500, fontSize: 21, fontFamily: "itc-avant-garde-gothic-pro", marginBottom: 15 }}>
                  Digital Marketing<br />Services
                </div>
                <a href="/ai-studio/" className="header-div">
                  <img alt="AI Studio" className="header-ai" src={headerai} loading="lazy" />
                </a>
                <a href="/flatart-lab/" className="header-div">
                  <img alt="Flatart Lab" className="header-ai" src={headerlab} loading="lazy" />
                </a>
              </div>
              <div className="col-md-8 header-deskttop">
                <div className="hizmetler-container">
                  <div className="hizmetler-sol">
                    <Link to="/digital-marketing-consultancy/" className="hizmet-new-flex clickable-wrapper">
                      <img alt="Digital Consultancy" className="hizmet-uploads-ico" src={hizmetone} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Digital Consultancy</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/search-engine-optimization/">
                      <img alt="SEO" className="hizmet-uploads-ico" src={hizmetseo} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">SEO</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/digital-ads/">
                      <img alt="Digital Ads" className="hizmet-uploads-ico" src={hizmetreklam} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Digital Ads</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/web-development/">
                      <img alt="Web &amp; Mobile Development" className="hizmet-uploads-ico" src={hizmetweb} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Web &amp; Mobile Development</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/social-media/">
                      <img alt="Social Media" className="hizmet-uploads-ico" src={hizmetsocial} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Social Media Management</span>
                      </div>
                    </Link>
                  </div>
                  <div className="hizmetler-sag">
                    <Link className="hizmet-new-flex clickable-area" to="/ai-consulting/">
                      <img alt="AI Consulting" className="hizmet-uploads-ico" src={hizmetyapay} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">AI Consulting</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/ui-ux-design/">
                      <img alt="UI / UX Design" className="hizmet-uploads-ico" src={hizmetdesign} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">UI / UX Design</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/whatsapp-marketing/">
                      <img alt="WhatsApp Marketing" className="hizmet-uploads-ico" src={hizmetwp} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">WhatsApp Marketing</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/content-marketing/">
                      <img alt="Content Marketing" className="hizmet-uploads-ico" src={hizmeticerik} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Content Marketing</span>
                      </div>
                    </Link>
                    <Link className="hizmet-new-flex clickable-area" to="/production-service/">
                      <img alt="Production Service" className="hizmet-uploads-ico" src={hizmetpro} loading="lazy" />
                      <div className="header-top-hizmet uploads">
                        <span className="hizmeta">Production Service</span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </li>

          {/* AI Studio Dropdown */}
          <li id="dropdown" className="li-header-2025">
            <Link className="header-2025" id="dropdown-Links" to="/ai-studio/">
              <div className="inner-content">
                AI Studio
                <svg className="svg-2025" xmlns="http://www.w3.org/2000/svg" width="10.822" height="7.797" viewBox="0 0 29.822 18.797">
                  <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                    <path id="Combined-Shape" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111"></path>
                  </g>
                </svg>
              </div>
            </Link>
            <div className="dropdown-menu container uploads test ai">
              <div className="col-md-6 ai">
                <div className="hizmet-new-flex ai">
                  <img alt="Generative AI Consulting" className="hizmet-uploads-ico" src={generative} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-consulting/">Generative AI Consulting</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="AI Agent Consulting" className="hizmet-uploads-ico" src={aihizmet} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-agent-consulting/">AI Agent Consulting</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="Generative Engine Optimization" className="hizmet-uploads-ico" src={answer} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/geo/">GEO</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="UGC - AGC" className="hizmet-uploads-ico" src={ugc} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-studio#ugc-agc-solutions">User &amp; AI Generated Content</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="AI Meetup" className="hizmet-uploads-ico" src={meetup} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-studio#ai-meetup">AI Meetup</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="ai-flex">
                  <div className="border-ai">
                    <img alt="AI Studio" className="ai-img" src={ailab} loading="lazy" />
                  </div>
                  <a href="/ai-studio/" className="ai-button upload">Explore Studio</a>
                </div>
              </div>
            </div>
          </li>

          {/* Flatart Lab Dropdown */}
          <li id="dropdown" className="li-header-2025">
            <Link className="header-2025" id="dropdown-Links" to="/flatart-lab/">
              <div className="inner-content">
                Flatart Lab
                <svg className="svg-2025" xmlns="http://www.w3.org/2000/svg" width="10.822" height="7.797" viewBox="0 0 29.822 18.797">
                  <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                    <path id="Combined-Shape" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111"></path>
                  </g>
                </svg>
              </div>
            </Link>
            <div className="dropdown-menu container uploads test ai lab">
              <div className="col-md-6 ai">
                <div className="hizmet-new-flex ai">
                  <img alt="LiveChatAI" className="hizmet-uploads-ico" src={livechatai} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#livechatai-section">LiveChatAI</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="Popupsmart" className="hizmet-uploads-ico" src={popupsmart} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#popupsmart-section">Popupsmart</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="Whatsapp App" className="hizmet-uploads-ico" src={whatsappapp} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#whatsapp-section">Whatsapp App</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="Qr Code Dynamic" className="hizmet-uploads-ico" src={qrcode} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#qrcode-section">Qr Code Dynamic</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="ai-flex">
                  <div className="border-ai">
                    <img alt="Flatart Lab" className="ai-img" src={aiheader} loading="lazy" />
                  </div>
                  <a className="ai-button upload" href="/flatart-lab/">Explore Products</a>
                </div>
              </div>
            </div>
          </li>

          <li><Link to="/blog/" activeClassName="active-nav">Blog</Link></li>
          <li><Link to="/contact/" activeClassName="active-nav">Contact Us</Link></li>
          <li><a href="https://flatart.com.tr/" className="tr">Tr</a></li>
        </ul>
      </div>

      {/* Mobile Menu */}
      <div className="nav-bar_mobil mobil-deactive">
        <ul className="nav-bar_mobil-items">
          <input type="checkbox" id="openWorks" name="openWorks" />
          <input type="checkbox" id="openai" name="openai" />
          <input type="checkbox" id="lab" name="lab" />
          <li id="whoweare"><Link to="/about/">Let's meet</Link></li>
          <li id="works"><Link to="/brands/">Brands</Link></li>
          <li id="whatwedo">
            <label htmlFor="openWorks" />
            <Link to="/services/">Services <svg xmlns="http://www.w3.org/2000/svg" width="13.822" height="7.797" viewBox="0 0 29.822 18.797">
              <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                <path id="Path_449" data-name="Path 449" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111" />
              </g>
            </svg></Link>
            <div className="dropdown-mobil">
              <p className="dropdown-mobil_desc">360° Digital Marketing</p>
              <div className="mobil-des">
                <a href="/ai-studio/" className="header-div des">
                  <img alt="AI Studio" className="header-ai des" src={headerai} loading="lazy" />
                </a>
                <a href="/flatart-lab/" className="header-div des">
                  <img alt="Flatart Lab" className="header-ai des" src={headerlab} loading="lazy" />
                </a>
              </div>
              <div className="dropdown-mobil_items">
                <div className="services-mobil-nav des">
                  <div className="hizmet-new-flex des">
                    <img alt="Digital Consultancy" className="hizmet-uploads-ico" src={hizmetone} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/digital-marketing-consultancy/">Digital Consultancy</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="SEO" className="hizmet-uploads-ico" src={hizmetseo} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/search-engine-optimization/">SEO</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="Digital Ads" className="hizmet-uploads-ico" src={hizmetreklam} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/digital-ads/">Digital Ads</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="Web &amp; Mobile Development" className="hizmet-uploads-ico" src={hizmetweb} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/web-development/">Web &amp; Mobile Development</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="Social Media" className="hizmet-uploads-ico" src={hizmetsocial} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/social-media/">Social Media Management</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="AI Consulting" className="hizmet-uploads-ico" src={hizmetyapay} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/ai-consulting/">AI Consulting</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="UI / UX Design" className="hizmet-uploads-ico" src={hizmetdesign} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/ui-ux-design/">UI / UX Design</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="WhatsApp Marketing" className="hizmet-uploads-ico" src={hizmetwp} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/whatsapp-marketing/">WhatsApp Marketing</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="Content Marketing" className="hizmet-uploads-ico" src={hizmeticerik} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/content-marketing/">Content Marketing</Link>
                    </div>
                  </div>
                  <div className="hizmet-new-flex des">
                    <img alt="Production Service" className="hizmet-uploads-ico" src={hizmetpro} loading="lazy" />
                    <div className="header-top-hizmet uploads">
                      <Link className="hizmeta" to="/production-service/">Production Service</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li id="aiai">
            <label htmlFor="openai" />
            <Link to="/ai-studio/">AI Studio <svg xmlns="http://www.w3.org/2000/svg" width="13.822" height="7.797" viewBox="0 0 29.822 18.797">
              <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                <path id="Combined-Shape" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111" />
              </g>
            </svg></Link>
            <div className="dropdown-mobil">
              <div className="col-md-6 ai">
                <div className="hizmet-new-flex">
                  <img alt="Generative AI" className="hizmet-uploads-ico" src={generative} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-consulting/">Generative AI Consulting</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex">
                  <img alt="AI Agent Consulting" className="hizmet-uploads-ico" src={aihizmet} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-agent-consulting/">AI Agent Consulting</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex">
                  <img alt="GEO" className="hizmet-uploads-ico" src={answer} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/geo/">Answer Engine Optimization</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex">
                  <img alt="UGC-AGC" className="hizmet-uploads-ico" src={ugc} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-studio#ugc-agc-solutions">User &amp; AI Generated Content</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex">
                  <img alt="AI Meetup" className="hizmet-uploads-ico" src={meetup} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/ai-studio#ai-meetup">AI Meetup</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 des">
                <div className="ai-flex">
                  <div className="border-ai">
                    <img alt="AI Studio" className="ai-img" src={ailab} loading="lazy" />
                  </div>
                  <a href="/ai-studio/" className="ai-button upload">Explore Studio</a>
                </div>
              </div>
            </div>
          </li>

          <li id="lablab">
            <label htmlFor="lab" />
            <Link to="/flatart-lab/">Flatart Lab <svg xmlns="http://www.w3.org/2000/svg" width="13.822" height="7.797" viewBox="0 0 29.822 18.797">
              <g id="right-chevron" transform="translate(29.822 -82.222) rotate(90)">
                <path id="Combined-Shape" d="M100.31,13.188,87.831.727a2.4,2.4,0,0,0-3.446,0L82.931,2.163a2.344,2.344,0,0,0-.708,1.722,2.451,2.451,0,0,0,.708,1.742l9.3,9.284-9.3,9.3a2.345,2.345,0,0,0-.708,1.723,2.451,2.451,0,0,0,.708,1.742l1.455,1.436a2.449,2.449,0,0,0,3.446,0l12.48-12.461a2.451,2.451,0,0,0,.709-1.742A2.344,2.344,0,0,0,100.31,13.188Z" transform="translate(0 0)" fill="#111" />
              </g>
            </svg></Link>
            <div className="dropdown-mobil">
              <div className="col-md-6 ai">
                <div className="hizmet-new-flex ai">
                  <img alt="LiveChatAI" className="hizmet-uploads-ico" src={livechatai} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#livechatai-section">LiveChatAI</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="Popupsmart" className="hizmet-uploads-ico" src={popupsmart} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#popupsmart-section">Popupsmart</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="WhatsApp App" className="hizmet-uploads-ico" src={whatsappapp} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#whatsapp-section">Whatsapp App</Link>
                  </div>
                </div>
                <div className="hizmet-new-flex ai">
                  <img alt="QR Code" className="hizmet-uploads-ico" src={qrcode} loading="lazy" />
                  <div className="header-top-hizmet uploads">
                    <Link className="hizmeta" to="/flatart-lab#qrcode-section">Qr Code Dynamic</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 des">
                <div className="ai-flex">
                  <div className="border-ai">
                    <img alt="Flatart Lab" className="ai-img" src={ailab} loading="lazy" />
                  </div>
                  <a href="/flatart-lab/" className="ai-button upload">Explore Products</a>
                </div>
              </div>
            </div>
          </li>

          <li><Link to="/blog/">Blog</Link></li>
          <li><Link to="/contact/">Contact Us</Link></li>
          <li><a href="https://flatart.com.tr/" className="tr">Tr</a></li>
        </ul>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
